var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGr4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon-col-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop_page",
    "data-name": "shop page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4_col",
    "data-name": "4_col"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M.75 0a.76.76 0 01.75.75v11a.76.76 0 01-.75.75.76.76 0 01-.75-.75v-11A.76.76 0 01.75 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    d: "M4.75 0a.76.76 0 01.75.75v11a.76.76 0 01-.75.75.76.76 0 01-.75-.75v-11A.76.76 0 014.75 0z",
    "data-name": "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    d: "M8.75 0a.76.76 0 01.75.75v11a.76.76 0 01-.75.75.76.76 0 01-.75-.75v-11A.76.76 0 018.75 0z",
    "data-name": "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4",
    d: "M12.75 0a.76.76 0 01.75.75v11a.76.76 0 01-.75.75.76.76 0 01-.75-.75v-11a.76.76 0 01.75-.75z",
    "data-name": "Rectangle"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr4);
export default __webpack_public_path__ + "static/media/gr4.d9968d3bbd52ea1f4335bf10ffd74d82.svg";
export { ForwardRef as ReactComponent };